const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-gray-800 text-white p-3 rounded shadow-lg">
        <p className="text-sm font-semibold">Year: {label}</p>
        <p className="text-sm">Citations: {payload[0].value}</p>
      </div>
    );
  }

  return null;
};
export default CustomTooltip;